import { graphql } from '@apollo/client/react/hoc'

import mutation from './mutation.graphql'

const mapMutateToProps = ({ mutate }) => ({
  updateBrowseStoresView: isListView => {
    mutate({
      variables: {
        settings: {
          browseStoresView: isListView ? 'list' : 'grid',
        },
      },
    })
  },
})

const withUpdateUserSettings = graphql(mutation, {
  props: mapMutateToProps,
})

export default withUpdateUserSettings
